import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
// Components
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

//data table and preloader
import Preloader from "../../components/Preloader/Preloader";
import { createMuiTheme, MuiThemeProvider, withStyles} from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";

//MessageBox
import MessageBox from "../../components/MessageBox/MessageBox";
import LoadingModal from "../../components/Modal/LoadingModal";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
		marginTop: "1em",
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#4f537e",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	  disabled: {},
});

const getMuiTheme = () => createMuiTheme({
	overrides: {
	  MUIDataTableHeadCell: {
		// root: {
		//   '&:nth-child(1)': {
		// 	width: 120
		//   },	
		//   '&:nth-child(2)': {
		// 	width: 120
		//   },
		//   '&:nth-child(3)': {
		// 	width: 160
		//   },
		//   '&:nth-child(4)': {
		// 	width: 160
		//   },
		// }
	  }
	}
  });

  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth()+1; 
  const yyyy = today.getFullYear();
  if(dd<10) 
	{
	    dd='0'+dd;
	} 

 if(mm<10) 
	{
	    mm='0'+mm;
	}

const PurchaseOrderReceiveInfo = () => {
	const { pono, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in 2nd table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [supRefNo, setSupRefNo] = useState('');
	const [dataLoaded, setDataLoaded] = useState(false);
	const [showModal, setShowModal] = useState(false);
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	let history = useHistory();
	const [btnDisabled, setBtnDisabled] = useState(true);
	const [itemsToReceive, setItemsToReceive] = useState([]);

	// componentDidMount / document.ready ?
	useEffect(() => {
			console.log(yyyy+"-"+mm+"-"+dd);
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'po_receive_form', {
			params:{
				pono: pono,
				jc_u_idno: branchidno
			}
		}).then((res) => {
			// console.log(res.data.data[1]);
			setItems(res.data.data[1].item_info);
			setSupplierInfo(res.data.data[0].customer_info);
			setShipTotal(res.data.data[0].customer_info.shipping);
			setPoTotal(res.data.data[0].customer_info.total - res.data.data[0].customer_info.shipping);
			setGrandTotal(res.data.data[0].customer_info.total);
			setDataLoaded(true);
			//setNotes(res.data.data[1].poreturn_summary.notes);
		}).catch((error) => {
			// console.log(error);
			setDataLoaded(true);
		});
	};	

	const columns = [
		{
			name: "item_name",
			label: "Item Name",
			options: {
				sort: false,
				filter: false,
			},
		},
		{
			name: "uomDesc",
			label: "Unit",
			options:{
				sort: false,
				filter: false,
			}
		},
		{
			name: "qty",
			label: "PO Qty",
			options: {
				sort: false,
				filter: false,
				customHeadRender: (o, updateDirection) => {
					return <th key={222} style={{textAlign: 'right', paddingRight:"1em"}}>
						{o.label}
					</th>;
				},
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			},
				customBodyRender: (value, tableMeta, updateValue) => { //table data
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
		},
		{
			name: "qty_to_receive",
			label: "Qty To Receive",
			options: {
				sort: false,
				filter: false,
				customHeadRender: (o, updateDirection) => {
					return <th key={111} style={{textAlign: 'right', paddingRight:"1em"}}>
						{o.label}
					</th>;
				},
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			},
				customBodyRender: (value, tableMeta, updateValue) => { //table data
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
		},
		{
			name: "price",
			label: "Price",
			options: {
				sort: false,
				filter: false,
				customHeadRender: (o, updateDirection) => {
					return <th key={333} style={{textAlign: 'right', paddingRight:"1em"}}>
						{o.label}
					</th>;
				},
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			},
				customBodyRender: (value, tableMeta, updateValue) => { //table data
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
		},
		{
			name: "qty_to_receive",
			label: "Qty to Receive",
			options: {
				sort: false,
				filter: false,
				customBodyRenderLite: (dataIndex) => {
					let qtybalance =  items[dataIndex].qtybalance;
					let count =  items[dataIndex].count;
					let qty =  items[dataIndex].qty;
					let qty_to_receive =  items[dataIndex].qty_to_receive;
					let item_id =  items[dataIndex].item_id;
				// if($rowrec["qty"]==$rowrec["qtyrcv"])
                // {
                //     $echo.='<td>Complete Delivery</td>';
                //     $echo.='<input type="hidden" id="qtytoreceive'.$count.'" name="qtytoreceive'.$count.'" value="x" />';
                // }
                // else
                // {
                //     $echo.='<td><input class="form-control" type="text" id="qtytoreceive'.$count.'" name="qtytoreceive'.$count.'" value="0" onchange="rcvAllocate('.$count.','.$qtybalance.');" /></td>';
				// }
					if(qty_to_receive===qty){
						return(
							<div>Complete Delivery</div>
						)
					}else{
						return(
							<TextField 
									classes={classes.rightTxt}
									placeholder="Enter amount to receive" 
									// inputProps={{ 'aria-label': 'Amount' }} 
									inputProps={{
										style: { textAlign: "right" },
										'aria-label': 'Amount' 
									  }}
									key={count}
									defaultValue="0"
									type="number"
									id={'qtytoreceive'+count}
									fullWidth
									onBlur={(e)=> rcvAllocate(count, qtybalance, e, item_id, qty)}
							/>
								  
					);
					}
				}
			}
		},
	];

	const options = {
		//hide toolbar functions
		toolbar:false,
		filter: false,
		viewColumns: false,
		search: false,
		download: false,
		print: false,
		csv: false,
		sort:false,
		// filterType: "dropdown",
		selectableRows: "none",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		// tableBodyHeight,
	};


	const updateQtyToReceive = (rcvQty, item_id, qty) =>{
		let found = itemsToReceive.some(x => x.item_id === item_id);
		if(found){
			let newItems = itemsToReceive.map((it)=> {
				if(it.item_id === item_id){ //add
					it.qty_to_receive = rcvQty;
				  }
			  return it;
			});
			setItemsToReceive(newItems);
		}else{
			setItemsToReceive([...itemsToReceive, 
				{
					item_id: item_id,
					qty: qty,
					qty_to_receive: rcvQty
				}
			]);
		}

	}

	const removeItem = (item_id) => {
		let newItems = itemsToReceive.filter((it)=>{
			return (it.item_id !== item_id);
		})
		setItemsToReceive(newItems);
	}

	//original validation logic in boss' code
	function rcvAllocate(count,qtybalance, e, item_id, qty) {
		    var fieldID = 'qtytoreceive'+count;
		    var fieldrun = 'qtytoreceive';
			var rcvQty = e.target.value;
			//var rcvQty = document.getElementById(fieldID).value; rcvQty=rcvQty.replace(/#/ig,"").replace(/&/ig,"").replace(/'"/ig,"");
		    var totalrows = supplierInfo.totalrows;
		    var suprefno = supRefNo;
		
		    var diff=0;
		
		    var checker=1;
		    if (rcvQty === "")
		    {
				//document.getElementById(fieldID).value=0;
				e.target.value = 0; 
				removeItem(item_id);
		    }
		    else
		    {
		        if(parseFloat(rcvQty) || (rcvQty===0))
		        {
		           if (rcvQty>qtybalance)
		           {
						setMsgType("warning");
						setMsg("ERROR: Qty to receive exceeds the unreceived quantity.");
						setShowMsgBox(true);
						setTimeout(() => {
							setShowMsgBox(false);
						}, 2500)
						e.target.value = 0; 
				   }else{
					updateQtyToReceive(rcvQty, item_id, qty);
				   }
		        }
		        else
		        {
					//document.getElementById(fieldID).value=0;
					e.target.value = 0; 
					removeItem(item_id);
		        }
		    }
		
		    if (suprefno === "")
		    {
				//document.getElementById("suprefno").style.border='1px solid red'; checker=2;
				setMsgType("warning");
				setMsg("ERROR: SupRefNo required.");
				setShowMsgBox(true);
				setTimeout(() => {
					setShowMsgBox(false);
				}, 2500)
				e.target.value = 0; 
				removeItem(item_id);
		    }
		    else
		    {
		       //document.getElementById("suprefno").style.border='1px solid #c8c8c8';
		    }
		
		    if (checker===1)
		    {
		        var totalamt=0;
		        for(var a=1; a<=totalrows; a++)
		        {
		            fieldrun = 'qtytoreceive'+a;
		            var val = document.getElementById(fieldrun).value;
		            if (val==="x")
		            {
		              val=0;
		            }
		            totalamt = (totalamt*1)+(val*1);
		        }
			
		        if (totalamt>=0)
		        {
		            if(totalamt===0)
		            {
						//document.getElementById("processBtn").disabled = true;
						setBtnDisabled(true);
		            }
		            else
		            {
						//document.getElementById("processBtn").disabled = false;
						setBtnDisabled(false);
		            }
		        }
		        else
		        {
		            // alert("ERROR: No Qty to Receive has been found.");
					//document.getElementById(fieldID).value=0;
					setMsgType("warning");
					setMsg("ERROR: No Qty to Receive has been found.");
					setShowMsgBox(true);
					setTimeout(() => {
						setShowMsgBox(false);
					}, 2500)
					e.target.value = 0; 
					removeItem(item_id);
		        }
		    }
		    else
		    {
		        // alert("ERROR: Please make sure all values entered are correct.");
				// document.getElementById(fieldID).value=0;
				setMsgType("warning");
				setMsg("ERROR: Please make sure all values entered are correct.");
				setShowMsgBox(true);
				setTimeout(() => {
					setShowMsgBox(false);
				}, 2500)
				e.target.value = 0; 
				removeItem(item_id);
		    }
		
		}

	const save_receive_po = async () => {
		setShowModal(true); //show loading/please wait modal
		setBtnDisabled(true); // disable button to avoid multiple saves
		const formData = new FormData();
		formData.append("jc_uname", get_cookies('username'));
		formData.append("jc_u_idno", branchidno);
		formData.append("item_array", JSON.stringify(itemsToReceive));
		formData.append("supplier", supplierInfo.supplier_id);
		formData.append("warehouse", supplierInfo.warehouse);
		formData.append("rcvno", supplierInfo.rcvno);
		formData.append("pono", pono);
		formData.append("suprefno", supRefNo);
		formData.append("trandate", yyyy+"-"+mm+"-"+dd);
		formData.append("rcvdate",  yyyy+"-"+mm+"-"+dd);
	  

		await axios.post(process.env.REACT_APP_API_URL+'po_receive', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("PO Receive Success");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/purchases/purchases-order-receive');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/purchases"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/purchases/purchases-order-receive"}><h4 style={{color:"#339933"}}>Purchase Order Receive </h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Purchase Order Receive Info #{pono}</h4>
				{/* <h4>supplier id: {supid} - delivery_date: {delivery_date}</h4> test if param values were passed*/}
			</div>
			<div className="page-container">
				<LoadingModal showModal={showModal}/>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12}>
								<div className={classes.subTitle}>
									Purchase Order Receive
								</div>
								<div className={classes.title}>
									{supplierInfo.display_title}
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>

							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>

							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Date: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.date_of_delivery || "Date"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Deliver From: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.deliver_from || "Returned To"}
								</Grid>
							</Grid>

							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.mode_of_payment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Contact #:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.contactno || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.address || "Address"}
								</Grid>
							</Grid>
						</div>	
					</CardContent>
				</Card>

						{!dataLoaded ? (
							<Preloader />
						) : (
							<MuiThemeProvider theme={getMuiTheme()}>
								<Card style={{marginBottom:"1em"}}>
									<CardContent>			
										<TextField 
											classes={classes.rightTxt}
											placeholder="Suprefno" 
											// inputProps={{ 'aria-label': 'Amount' }} 
											inputProps={{
												'aria-label': 'Suprefno' 
											  }}
											type="text"
											id="suprefno"
											value={supRefNo}
											onChange={(e)=> setSupRefNo(e.target.value)}
										/>
									</CardContent>
							    </Card>

								<MUIDataTable
											title={
												<div>
													<div className="table-subtitle">Items</div>
													<div className="table-title">
													Items To Receive
													</div>
												</div>
											}
											data={items}
											columns={columns}
											options={options}
								/>
						  </MuiThemeProvider>
						// <div>render table here</div>
						)}		
				<Card style={{marginTop: "1em"}}>
					<CardContent>				
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{/* Shipping: 0.00	shipTotal	 */}
									{"Shipping: "+ numeral(shipTotal).format('0,0.00')}							
								</div>
								<div style={{textAlign:"right"}}className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(grandTotal).format('0,0.00')}
								</div>	
							</div>
						</div>
					</CardContent>
				</Card>
				{/* <div className={classes.buttonContainer} >
					<ColorButton disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{save_receive_po();}}
					classes={{
						root: classes.root, 
							disabled: classes.disabled}}>
						Process Receive Inventory
					</ColorButton>
				</div> */}
			</div>
		</div>
	);
};

export default PurchaseOrderReceiveInfo;
